import mapbox from 'mapbox-gl';
// https://docs.mapbox.com/help/glossary/access-token/
mapbox.accessToken = "pk.eyJ1IjoiZ3VsbGVzbnVmZnMiLCJhIjoiY2tzYTh6d2xoMGM1aDJubjNrMzVqeG5vNCJ9.SWbHSl1DacMfG0ylns-5Xg";
const key = {};
export { mapbox, key };
